import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_FEILD, EDIT_FEILD, CREATE_FEILD } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteFeild(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_FEILD}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editFeild(formData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_FEILD}`, formData, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createFeild(formData, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_FEILD}`, formData, configReq(token));
}
